'use client';

import { useAtomRefresh, useAtomValue } from '@effect/atom-react';
import { GlossaryIndexTerm, GlossaryIndexTermSkeleton } from '@vs-shop/commerce-ui/glossaryIndex';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';

import { glossaryTermsPerPage } from '@vs-shop/engine/config/glossary';

import { GlossaryLoadError } from './GlossaryLoadError';

import { fetchGlossaryTermsAtom } from '../../../../effect/atom/glossary/fetchGlossaryTerms';

type Props = {
  alphabetFilter: string;
  page: number;
};

export function GlossaryAlphabetListPerPage({ alphabetFilter, page }: Props) {
  const pageAtom = fetchGlossaryTermsAtom(alphabetFilter, null, false, page, glossaryTermsPerPage);
  const response = useAtomValue(pageAtom);
  const retry = useAtomRefresh(pageAtom);

  return AsyncResult.match(response, {
    onInitial: () => (
      <>
        {Array.from({ length: 10 }, (_, i) => (
          <GlossaryIndexTermSkeleton key={`page-${String(page)}-skeleton-${String(i)}`} />
        ))}
      </>
    ),
    onFailure: () => <GlossaryLoadError onRetry={retry} className="break-inside-avoid" />,
    onSuccess: ({ value }) => (
      <>
        {value['hydra:member'].map((term) => (
          <GlossaryIndexTerm
            key={term.code}
            href={term.routerUrl}
            className="mb-2 break-inside-avoid"
          >
            {term.name ?? ''}
          </GlossaryIndexTerm>
        ))}
      </>
    ),
  });
}
